import i18n from '../../../../i18n'
import backendStyle from '../../../../backendStyle'

export default {
  newInstance (tool) {
    return {
      createCfg (myCfg = {}) {
        const cfg = {
          // 如果需要从接口获取数据，则此参数必传
          apiMethod: undefined,

          placeholder: '',
          loading: false,
          // return的内容作为options
          handleRender: res => backendStyle[process.env.VUE_APP_BACKENDER].renderList(res),
          handleRequestData: () => ({}),
          options: [],
          oldPlaceholder: ''
        }

        return Object.assign(cfg, myCfg)
      },
      loadData (cfg) {
        return new Promise((resolve) => {
          this.beforeLoad(cfg).then(() => {
            cfg.apiMethod(cfg.handleRequestData()).then((res) => {
              this.afterLoad(cfg, res)
              resolve(res)
            })
          })
        })
      },
      beforeLoad (cfg) {
        return new Promise((resolve) => {
          cfg.loading = true
          if (!cfg.oldPlaceholder) {
            cfg.oldPlaceholder = cfg.placeholder
          }
          cfg.placeholder = i18n.messages[i18n.locale].message.requestLoading
          cfg.options = []
          resolve()
        })
      },
      afterLoad (cfg, res) {
        tool.wrapResponse(res).then(() => {
          cfg.options = cfg.handleRender(res)
          if (cfg.options.length > 0) {
            cfg.placeholder = cfg.oldPlaceholder
          } else {
            cfg.placeholder = i18n.messages[i18n.locale].message.noData
          }
        }).catch(() => {
          cfg.placeholder = tool.getResponseError(res)
        })

        cfg.loading = false
      },
      matchValue (cfg, columnName, defaultValue, returnFirst = false) {
        if (!cfg.options || cfg.options.length === 0) {
          return undefined
        }

        if (columnName) {
          if (defaultValue !== undefined && defaultValue !== null) {
            const arr = cfg.options.filter(d => d[columnName] === defaultValue)

            if (!arr || arr.length === 0) {
              return returnFirst ? cfg.options[0][columnName] : undefined
            }

            return arr[0][columnName]
          }

          return returnFirst ? cfg.options[0][columnName] : undefined
        }

        if (defaultValue !== undefined && defaultValue !== null) {
          const arr = cfg.options.filter(d => d === defaultValue)

          if (!arr || arr.length === 0) {
            return returnFirst ? cfg.options[0] : undefined
          }

          return arr[0]
        }

        return returnFirst ? cfg.options[0] : undefined
      }
    }
  }
}
